import { useRefreshSiteContributions } from "../api";
import styles from "./RefreshSiteSection.module.css";

const NOT_REFRESHED: Record<string, string> = {
  site_not_found: "This site is no longer on admin.inrange.io.",
  no_linked_site: "This project isn't linked to a site on admin.inrange.io.",
};

// The single-project counterpart of the Projects page's "Refresh admin data".
export const RefreshSiteSection = ({ projectId }: { projectId: string }) => {
  const refresh = useRefreshSiteContributions();
  const result = refresh.data;

  return (
    <div className={styles.row}>
      <div className={styles.text}>
        <p className={styles.help}>
          Re-pulls all admin data for this project, including cost and survey.
        </p>
        {refresh.isError && (
          <p className={styles.problem} role="status">
            Couldn&apos;t refresh: {refresh.error.message}
          </p>
        )}
        {result && !refresh.isLoading && (
          <p
            className={result.refreshed ? styles.done : styles.problem}
            role="status"
          >
            {result.refreshed
              ? "Refreshed."
              : (NOT_REFRESHED[result.reason ?? ""] ??
                "Nothing was refreshed.")}
          </p>
        )}
      </div>
      <button
        type="button"
        className={styles.button}
        onClick={() => refresh.mutate(projectId)}
        disabled={!projectId || refresh.isLoading}
      >
        {refresh.isLoading ? "Refreshing…" : "Refresh admin data"}
      </button>
    </div>
  );
};
